import { useNavigate, useParams } from 'react-router-dom'

import { TrainingClassFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import type { TrainingsTrainingMembership } from './useDataSource'

interface SelectedItem {
  item: TrainingsTrainingMembership
  checked: boolean
}

interface BulkActionParams {
  itemsStatus: readonly SelectedItem[]
}

export const useBulkAction = (trainingClasses: TrainingClassFragment[]) => {
  const { id } = useParams()
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  return (action: string, selectedRows: BulkActionParams) => {
    if (action === 'delete-all') {
      const membershipIds = [...selectedRows.itemsStatus]
        .filter((status) => status.checked)
        .map((status) => {
          const item = status.item
          if (item && item?.id) return item.id

          return null
        })
        .filter((membershipId): membershipId is number => membershipId !== null)

      navigate(
        navigation.trainings.list.details_revamp.view.participants.deleteParticipants.fullPath({
          id: Number(id),
        }),
        { state: { membershipIds } }
      )
    } else if (action === 'assign-to-group') {
      const emptyClasses = trainingClasses.length === 0

      const selectedAccessIds = [...selectedRows.itemsStatus]
        .filter((status) => status.checked)
        .map((status) => {
          const item = status.item
          if (item && item.access?.id) return item.access.id

          return null
        })
        .filter((accessId): accessId is number => accessId !== null)

      const assignToGroupPath = emptyClasses
        ? navigation.trainings.list.details_revamp.view.trainingClasses.tab.newClass.fullPath({
            id: Number(id),
          })
        : navigation.trainings.list.details_revamp.view.participants.assignParticipants.fullPath({
            id: Number(id),
          })
      navigate(assignToGroupPath, { state: { selectedAccessIds } })
    }
  }
}
